import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/Css/Blog.css"

const Blog = () => {
    const featuredPost = {
        title: 'How AI is Revolutionizing Real Estate Transaction Management',
        excerpt: 'Discover how artificial intelligence is transforming the way real estate professionals handle transactions, from contract analysis to automated task management.',
        author: 'Sarah Johnson',
        date: 'January 10, 2025',
        category: 'Industry Trends',
        readTime: '8 min read'
    };

    const posts = [
        {
            title: '5 Ways to Streamline Your Transaction Workflow',
            excerpt: 'Learn practical tips for reducing administrative burden and closing deals faster.',
            author: 'Michael Brown',
            date: 'January 8, 2025',
            category: 'Tips & Tricks',
            readTime: '5 min read'
        },
        {
            title: 'The Complete Guide to Real Estate Contract Analysis',
            excerpt: 'Everything you need to know about reviewing and understanding real estate contracts.',
            author: 'Emily Davis',
            date: 'January 5, 2025',
            category: 'Guides',
            readTime: '12 min read'
        },
        {
            title: 'Why Transaction Coordinators Love Deal to Close AI',
            excerpt: 'Hear from TCs who have transformed their workflow with our AI-powered tools.',
            author: 'Alex Chen',
            date: 'January 2, 2025',
            category: 'Case Studies',
            readTime: '6 min read'
        },
        {
            title: 'Setting Up Your First Automated Workflow',
            excerpt: 'A step-by-step guide to creating automated task sequences for your transactions.',
            author: 'Sarah Johnson',
            date: 'December 28, 2024',
            category: 'Tutorials',
            readTime: '7 min read'
        },
        {
            title: 'The Future of Real Estate Technology in 2025',
            excerpt: 'Our predictions for the most impactful tech trends in real estate this year.',
            author: 'Michael Brown',
            date: 'December 22, 2024',
            category: 'Industry Trends',
            readTime: '10 min read'
        },
        {
            title: 'Maximizing Client Communication with AI',
            excerpt: 'How to use AI-powered tools to improve client relationships and satisfaction.',
            author: 'Emily Davis',
            date: 'December 18, 2024',
            category: 'Tips & Tricks',
            readTime: '6 min read'
        }
    ];

    const categories = ['All', 'Industry Trends', 'Tips & Tricks', 'Guides', 'Tutorials', 'Case Studies'];

    return (
        <div className="blog-page">
            {/* Hero */}
            <section className="blog-hero">
                <div className="container">
                    <span className="badge">Blog</span>
                    <h1 className="blog-hero__title">Insights & Resources</h1>
                    <p className="blog-hero__subtitle">
                        Expert advice, industry trends, and tips to help you close more deals.
                    </p>
                </div>
            </section>

            {/* Featured Post */}
            <section className="blog-featured section">
                <div className="container">
                    <div className="featured-post">
                        <div className="featured-post__image">
                            <div className="featured-post__image-placeholder">
                                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3">
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                    <circle cx="8.5" cy="8.5" r="1.5" />
                                    <polyline points="21 15 16 10 5 21" />
                                </svg>
                            </div>
                        </div>
                        <div className="featured-post__content">
                            <span className="featured-post__category">{featuredPost.category}</span>
                            <h2 className="featured-post__title">{featuredPost.title}</h2>
                            <p className="featured-post__excerpt">{featuredPost.excerpt}</p>
                            <div className="featured-post__meta">
                                <span className="featured-post__author">{featuredPost.author}</span>
                                <span className="featured-post__divider">•</span>
                                <span className="featured-post__date">{featuredPost.date}</span>
                                <span className="featured-post__divider">•</span>
                                <span className="featured-post__read-time">{featuredPost.readTime}</span>
                            </div>
                            {/* <a href="#" className="btn btn-primary">Read Article</a> */}
                            <Link to="#" className="btn btn-primary">Read Article</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Blog Posts */}
            <section className="blog-posts section">
                <div className="container">
                    <div className="blog-posts__header">
                        <h2 className="section-title">Latest Articles</h2>
                        <div className="blog-posts__categories">
                            {categories.map((category, index) => (
                                <button
                                    key={index}
                                    className={`blog-posts__category ${index === 0 ? 'blog-posts__category--active' : ''}`}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="posts__grid">
                        {posts.map((post, index) => (
                            <article key={index} className="post-card">
                                <div className="post-card__image">
                                    <div className="post-card__image-placeholder"></div>
                                </div>
                                <div className="post-card__content">
                                    <span className="post-card__category">{post.category}</span>
                                    <h3 className="post-card__title">{post.title}</h3>
                                    <p className="post-card__excerpt">{post.excerpt}</p>
                                    <div className="post-card__meta">
                                        <span className="post-card__author">{post.author}</span>
                                        <span className="post-card__divider">•</span>
                                        <span className="post-card__read-time">{post.readTime}</span>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>

                    <div className="blog-posts__load-more">
                        <button className="btn btn-secondary">Load More Articles</button>
                    </div>
                </div>
            </section>

            {/* Newsletter */}
            <section className="blog-newsletter">
                <div className="container">
                    <div className="newsletter-card">
                        <h2 className="newsletter-card__title">Subscribe to Our Newsletter</h2>
                        <p className="newsletter-card__description">
                            Get the latest insights, tips, and product updates delivered to your inbox.
                        </p>
                        <form className="newsletter-card__form">
                            <input type="email" placeholder="Enter your email" required />
                        </form>
                        <button type="submit" className="btn btn-primary" style={{ border: "1px solid #696969" }}>Subscribe</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Blog;
